import {
  Paper,
  SegmentedControl,
  Stack,
  Title,
  Text,
  Image,
  List,
  Blockquote,
} from '@mantine/core'
import { useState } from 'react'
import {
  DeviceTypes,
  FireTVDownloadSteps,
  GooglePlayDownloadSteps,
} from '../../../utils/constants'
import RokuLogo from '../../../assets/rokuLogo.png'
import FireTVLogo from '../../../assets/fireTVLogo.png'
import googlePlayLogo from '../../../assets/googlePlayLogo.png'

const controlOptions = [
  {
    value: DeviceTypes.FireTV.toString(),
    label: 'Amazon Fire TV',
  },
  {
    value: DeviceTypes.SmartTV.toString(),
    label: 'Smart TV w/ Google Play',
  },
  { value: DeviceTypes.Roku.toString(), label: 'Roku' },
]

function DownloadTVAppInstructions() {
  const [selectedDeviceType, setSelectedDeviceType] = useState(
    DeviceTypes.FireTV.toString(),
  )
  return (
    <Stack h='100%' w='100%' maw={1000}>
      <SegmentedControl
        visibleFrom='xs'
        value={selectedDeviceType}
        onChange={setSelectedDeviceType}
        data={controlOptions}
      />
      <SegmentedControl
        w='100%'
        hiddenFrom='xs'
        orientation='vertical'
        value={selectedDeviceType}
        onChange={setSelectedDeviceType}
        data={controlOptions}
      />
      {selectedDeviceType === DeviceTypes.FireTV.toString() && (
        <Instructions logoUrl={FireTVLogo} steps={FireTVDownloadSteps} />
      )}
      {selectedDeviceType === DeviceTypes.SmartTV.toString() && (
        <Instructions
          logoUrl={googlePlayLogo}
          steps={GooglePlayDownloadSteps}
          note='Note: Some smart TVs do not support the Google Play Store. These
          devices will require you to purchase a streaming device (Fire TV
          Stick, Chromecast, etc.). The instructions below show the process for
          a TV that runs the Android TV operating system.'
        />
      )}
      {selectedDeviceType === DeviceTypes.Roku.toString() && (
        <RokuInstructions />
      )}
    </Stack>
  )
}

interface InstructionsListProps {
  steps: InstructionListStep[]
}

interface InstructionListStep {
  instructions: string
  imageUrl: string
}

interface InstructionsProps {
  logoUrl: string
  steps: InstructionListStep[]
  note?: string
}

function Instructions(props: InstructionsProps) {
  const { logoUrl, steps, note } = props
  return (
    <Paper withBorder w='100%' p={48} radius={10}>
      <Stack>
        <Image
          src={logoUrl}
          w={'50%'}
          maw={200}
          pb={32}
          style={{ alignSelf: 'center' }}
        />
        {note && <Blockquote color='orange'>{note}</Blockquote>}
        <InstructionsList steps={steps} />
      </Stack>
    </Paper>
  )
}

function InstructionsList(props: InstructionsListProps) {
  const { steps } = props
  return (
    <List fw={600} spacing='xl' size='xl' center type='ordered'>
      {steps.map((step, index) => (
        <div key={index}>
          <List.Item lh='sm'>{step.instructions}</List.Item>
          {step.imageUrl && (
            <Image src={step.imageUrl} pt={24} pb={24} w={'100%'} />
          )}
        </div>
      ))}
    </List>
  )
}

function RokuInstructions() {
  return (
    <Paper
      withBorder
      w='100%'
      mih={400}
      p={32}
      style={{
        display: 'flex',
      }}
      radius={10}
    >
      <Stack align='center' justify='center' w='100%' gap={0}>
        <Image src={RokuLogo} w={'50%'} maw={200} ta={'center'} />
        <Title ta='center' size={60}>
          Coming Soon!
        </Title>
        <Text ta='center' pt={24}>
          We are working hard to bring our display app to Roku. Check back soon!{' '}
          <br /> For now, you can purchase an Amazon Fire TV Stick and download
          our app
        </Text>
      </Stack>
    </Paper>
  )
}

export default DownloadTVAppInstructions
